export class AuthInfo {

    constructor(
        public $uid: string
    ) {

    }

    isLoggedIn() {
        return !!this.$uid;
    }

}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/security/auth-info.ts